
import { defineComponent, ref } from "vue";

export default defineComponent({
  name: "Message",
  props: {
    msg: {
      type: String,
      required: true
    },
    editMode: {
      type: Boolean,
      required: true
    }
  },
  setup(props, { emit }) {
    const showForm = ref(false);
    const inputWidth = ref("25ch");
    const newMsg = ref(props.msg.slice());

    function removeMessage() {
      emit("update:newMessage", "");
    }

    function onSubmit() {
      if (newMsg.value !== "") {
        emit("update:newMessage", newMsg.value);
      }
      return (showForm.value = false);
    }

    function updateInputWidth() {
      const min = 25;
      const max = 90;
      const currentWidth: number = newMsg.value.length;

      if (currentWidth > min && currentWidth <= max) {
        inputWidth.value = `${currentWidth}ch`;
      } else if (currentWidth >= max) {
        inputWidth.value = "90ch";
      } else {
        inputWidth.value = "25ch";
      }
    }

    return {
      showForm,
      inputWidth,
      newMsg,
      removeMessage,
      onSubmit,
      updateInputWidth
    };
  }
});
